const defaultOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

export const withDateOnly: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: undefined,
  minute: undefined,
};

export const withShortMonth: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

export const formatDate = (timestamp: string | number | Date, options = {}, locale = 'en-US') => {
  try {
    const date = new Date(timestamp);

    if (isNaN(date.getTime())) {
      throw new Error('Invalid timestamp provided.');
    }

    const finalOptions = { ...defaultOptions, ...options };

    return new Intl.DateTimeFormat(locale, finalOptions).format(date);
  } catch (error) {
    console.error('Error formatting date:', (error as Error).message);
    return '[formatDate] Invalid Date';
  }
};
